import { render, staticRenderFns } from "./forgetThePassword.vue?vue&type=template&id=443cb834&scoped=true&"
import script from "./forgetThePassword.vue?vue&type=script&lang=ts&"
export * from "./forgetThePassword.vue?vue&type=script&lang=ts&"
import style0 from "./forgetThePassword.vue?vue&type=style&index=0&id=443cb834&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "443cb834",
  null
  
)

export default component.exports